module.exports = __webpack_public_path__ + "img/edge_restauration_miel.d66d40cc.svg";